import { graphql } from 'gatsby';
import { Layout, Code, Showcase, ClassTable, Header } from "../../../../src/components";
import "../../../../src/pages/wt/utilities/flexbox/style.scss";
import data from "../../../../src/pages/wt/utilities/flexbox/data.json";
import changelog from "../../../../src/data/changelog.json";
import * as React from 'react';
export default {
  graphql,
  Layout,
  Code,
  Showcase,
  ClassTable,
  Header,
  data,
  changelog,
  React
};